import { render, staticRenderFns } from "./zsfa-dailog.vue?vue&type=template&id=532bb93e&scoped=true"
import script from "./zsfa-dailog.vue?vue&type=script&lang=js"
export * from "./zsfa-dailog.vue?vue&type=script&lang=js"
import style0 from "./zsfa-dailog.vue?vue&type=style&index=0&id=532bb93e&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532bb93e",
  null
  
)

export default component.exports